module.exports = __webpack_public_path__ + "img/logo.bc407979.png";